export enum UploadPostContentType {
  photoVideo,
  status,
  liveVideo,
}

export interface DialogUploadPostContentProps {
  isOpen: boolean;
  type: UploadPostContentType;
}

export interface DialogUploadEditPostContentProps {
  isOpen: boolean;
  postEdit: any;
  onSuccess: (post: any) => void;
}

export class PostUploadMediaType {
  private constructor(public readonly value: string) {}
  static video = new PostUploadMediaType("video");
  static photo = new PostUploadMediaType("photo");
  static status = new PostUploadMediaType("status");
  static live = new PostUploadMediaType("live");
}

